module.exports = __webpack_public_path__ + "static/media/TICKETS.52d57151.jpg";